"use client";

import {isPresentationRecord, presentedFields} from "@repo/ui/gailgpt/tool-presentation";
import {ReviewFields, type ToolDetailsProps} from "./ToolPresentationDetails";

/** Keep the review's reading order independent of JSON property and metadata order. */
export default function UseCaseToolDetails({presentation, parameters}: ToolDetailsProps) {
   const order = ["title", "description", "actions"];
   const property = (path: string[]) => path.length === 1 ? path[0] : path.length === 2 && path[0] === "body" ? path[1] : undefined;
   const rank = (path: string[]) => {const index = order.indexOf(property(path) ?? ""); return index < 0 ? order.length : index;};
   const fields = presentedFields(parameters, presentation.fields).sort((a, b) => rank(a.path) - rank(b.path)).map(field => {
      if (property(field.path) !== "actions" || !Array.isArray(field.value)) return field;
      return {...field, value: field.value.map(action => isPresentationRecord(action)
         ? Object.fromEntries(Object.entries(action).filter(([key, value]) => key !== "textScriptId" || (value != null && value !== "")))
         : action)};
   });
   return <div className="px-5 pb-5 pt-4"><ReviewFields fields={fields} /></div>;
}
